import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { validateUser, getAllUsers, updateOrder} from '../general/api'; // Importa la función de validación
import { loginSuccess, loginFailure, setData} from '../../actions/index';
import { Eye, EyeOff } from "lucide-react"
import './OrderManagement.css';

const OrderManagement = ({ navigationHistory, isEdit, order }) => {
    const user = useSelector((state) => state.auth.user);
    const dispatch = useDispatch();
    const [tomarOrden, setTomarOrden] = useState(false);
    const [orderStatus, setOrderStatus] = useState('');
    const [users, setUsers] = useState([]);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [showPassword, setShowPassword] = useState(false)

    const tableColumnsOrders = [
        { header: '# Orden', field: 'Id_Order', visible: false},
        { header: 'Código de Tarea', field: 'Internal_Code' },
        { header: 'Codigo de Maquína', field: 'Internall_Code_Machine' },
        { header: 'Tipo de Tarea', field: 'Name_Task_Type' },
        { header: 'Fecha Programada', field: 'Scheduled_Date' },
        { header: 'Estado', field: 'Status' },
        { header: 'Usuario Asignado', field: 'Name_User' },
        { header: 'Descripción de la Tarea', field: 'Description' },
        { header: 'Insumos usados', field: 'Supplies' }
    ];

    const estadosPosibles = [
        'Pendiente',
        'Asignada',
        'En Proceso',
        'Completada',
        'En Espera',
        'Cancelada',
        'Reprogramada',
        'En Revisión'
    ];

    const [formData, setFormData] = useState({
        Id_Order: '',
        Status: '',
        Name_User: '',
        Scheduled_Date: '',
        Priority: '',
        Observacion: ''
    });

    useEffect(() => {
        if (user && user.Id_Empresa) {
            const fetchUsers = async () => {
                try {
                    const response = await getAllUsers(user.Id_Empresa);
                    setUsers(response);
                } catch (error) {
                    console.error('Error al obtener los usuarios:', error);
                }
            };
    
            fetchUsers();
        }
    }, [user, user.Id_Empresa]) 

    useEffect(() => {
        if (order && order[0]) {
            setFormData({
                Id_Order: order[0].Id_Order || '',
                Status: order[0].Status || '',
                Name_User: order[0].Name_User || '',
                Scheduled_Date: order[0].Scheduled_Date || '',
                Priority: order[0].Priority || '',
                Observacion: ''
            });
            setOrderStatus(order[0].Status);
        }
        setTomarOrden(false);

    }, [order]);

    useEffect(() => {
        if ((formData.Status === 'Pendiente' || formData.Status === 'Asignada' || formData.Status === 'En Proceso') || formData.Observacion !== ''){
            setIsButtonDisabled(false);
        }else{
            setIsButtonDisabled(true);
        }
        
        
    }, [formData]);
    

    const renderField = (header, field, value, visible = true) => {
        if (!visible) return null;
        return (
            <tr key={field}>
                <td><strong>{header}</strong></td>
                <td>{value || ''}</td>
            </tr>
        );
    };

    const renderEditableField = (header, field, value, onChange) => {
        if (field === 'Scheduled_Date') {
            return (
                <tr key={field}>
                    <td><strong>{header}</strong></td>
                    <td>
                        <input
                            type="date"
                            name={field}
                            value={value || ''}
                            onChange={onChange}
                        />
                    </td>
                </tr>
            );
        } else if (field === 'Status') {
            return (
                <tr key={field}>
                    <td><strong>{header}</strong></td>
                    <td>
                        <select name={field} value={value || ''} onChange={onChange}>
                            {estadosPosibles.map(estado => (
                                <option key={estado} value={estado}>
                                    {estado}
                                </option>
                            ))}
                        </select>
                    </td>
                </tr>
            );
        } else if (field === 'Observacion') {
            return (
                <tr key={field}>
                    <td><strong>{header}</strong></td>
                    <td>
                        <input
                            type="text"
                            name={field}
                            value={value || ''}
                            onChange={onChange}
                            required
                        />
                    </td>
                </tr>
            );
        } else if (field === 'Name_User') {
            return (
                <tr key={field}>
                    <td><strong>{header}</strong></td>
                    <td>
                        <select name="Name_User" value={value} onChange={onChange}>
                            <option value=''>Selecciona un usuario</option>
                            {users.map(user => (
                                <option key={user.Id_User} value={user.Name_User}>
                                    {`${user.Name_User} - ${user.Cc_User}`}
                                </option>
                            ))}
                        </select>
                    </td>
                </tr>
            );
        }
        return (
            <tr key={field}>
                <td><strong>{header}</strong></td>
                <td>
                    <input
                        type="text"
                        name={field}
                        value={value || ''}
                        onChange={onChange}
                    />
                </td>
            </tr>
        );
    };
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    if (!order || !order[0]) {
        return (
            <div className="OrderManagement">
                <h2>Detalles de la Orden de Mantenimiento</h2>
                <p>No hay información disponible.</p>
                <button onClick={navigationHistory}>Regresar</button>
            </div>
        );
    }

    const TomarOrder = () => {
        setFormData({ ...formData, Status: estadosPosibles[(estadosPosibles.indexOf(formData.Status) + 1) % estadosPosibles.length] });
        setTomarOrden(true);
    }
    const llamarOrder = async () => {
        dispatch(setData('maquinas'));
        await ActualizarOrden(users.find(user => user.Name_User === formData.Name_User).Id_User);
        dispatch(setData('ordenes'));
        navigationHistory();
    }

    const ActualizarOrden = async (Id_User) => {
        try {
            // Llamar a la función updateOrder con los datos de formData
            const response = await updateOrder(
                formData.Id_Order,
                formData.Scheduled_Date,
                Id_User, // Asumo que Name_User es el assigned_user
                formData.Priority, // Puedes establecer la prioridad aquí según sea necesario
                formData.Status,
                formData.Observacion
            );
    
            // Manejo de la respuesta
            alert(JSON.stringify(response));
        } catch (error) {
            // Manejo de errores
            console.error('Error al actualizar la orden:', error);
            alert(error.message);
        }
    };
    

    const handleLogin = async (event) => {
      event.preventDefault();
      const form = event.target;
      const email = form.email.value;
      const password = form.password.value;

      try {
        const response = await validateUser(email, password);

        if (response && response.Id_User) {
            if (response.Id_User === user.Id_User){
                await ActualizarOrden(response.Id_User);
            }else{
                await ActualizarOrden(response.Id_User);
                dispatch(loginSuccess(response));
            }
          
        } else {
          dispatch(loginFailure(response.Error));
          alert(response.Error);
        }
      } catch (error) {
        alert(error.message);
        dispatch(loginFailure(error.message));
      }
      navigationHistory();
    };

    const renderButtonByStatus = (status) => {
        switch (status) {
            case 'Pendiente':
                return <button onClick={TomarOrder}>Tomar</button>;
            case 'Asignada':
                return <button onClick={TomarOrder}>Empezar</button>;
            case 'En Proceso':
                return <button onClick={TomarOrder}>Finalizar</button>;
            default:
                return null;
        }
    };

    return (
        <div className="OrderManagement">
            {tomarOrden ? (
                <div>
                    <div className="login-box">
                      <h2>Asignarme Orden de</h2>
                      <h2>Mantenimiento</h2>
                      <form onSubmit={handleLogin}>
                        <div className="input-group">
                          <label>E-mail:</label>
                          <input type="email" name="email" required />
                        </div>
                        <div className="input-group">
                          <label>Contraseña:</label>
                          <input type={showPassword ? 'text' : 'password'} name="password" required />
                          <button
                            className="eye-button"   
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                          </button>
                        </div>
                        <button className="button" type="submit">Ingresar</button>
                      </form>
                    </div>
                </div>
            ):(
                <div>
                    <h2>Detalles de la Orden de Mantenimiento</h2>
                    <table>
                        <tbody>
                            {tableColumnsOrders.map(column => {
                                if (isEdit && (column.field === 'Status' || column.field === 'Name_User' || column.field === 'Scheduled_Date')) {
                                    return renderEditableField(column.header, column.field, formData[column.field], handleChange);
                                } else {
                                    return renderField(column.header, column.field, order[0] && order[0][column.field], column.visible !== false);
                                }
                            })}
                            {formData.Status !== 'Pendiente' && formData.Status !== 'Asignada' && formData.Status !== 'En Proceso' && renderEditableField('Observación', 'Observacion', formData.Observacion, handleChange)}
                        </tbody>
                    </table>
                    <div className='OrderManagement-button-container'>
                        <button onClick={navigationHistory}>Regresar</button>
                        {!isEdit ? (
                            renderButtonByStatus(orderStatus)
                        ) : (
                            <button disabled ={isButtonDisabled} onClick={llamarOrder} >Guardar cambios</button>    
                        )}
                        
                    </div>
                </div>
            )}
        </div>
    );
};

export default OrderManagement;
